import {useRouter} from "next/router";

import {enforceArray, handleChecklistFilterChange, handleDropdownSelect, handleSearchChange, replaceRouterQueryParamsShallow} from "../helpers/FilterFunctions";
import Checklist from "./common/Checklist";
import {useEffect, useState} from "react";
import MobileFilterMenu from "./MobileFilterMenu/MobileFilterMenu";
import {Filter, FilterAnyLabels, PropertyTypeQueryKey} from "../data/Filter/Filter.config";
import {ArtDerUnterkunftItems, AusstattungItems, SchlafzimmerItems, VermietungCategories} from "../data/Filter/VermietungFilter.config";
import {NumberOfRooms} from "../enums/enums";
import {useTranslation} from "next-i18next";
import {CustomTFunction, TranslationsKeys} from "../TranslationTypes";

export default function VermietungMobileFilterMenu(props: {
	open: boolean;
	onClose: () => void;
}) {
	const {t} = useTranslation() as unknown as {
		t: CustomTFunction<TranslationsKeys>;
	};
	const router = useRouter();

	const bedroomQueryValue = router.query[Filter.BedroomsTotal.queryKey] ?? [
		FilterAnyLabels.BELIEBIG
	];
	const [bedroomSelectedItems, setBedroomSelectedItems] = useState<string[]>(
		bedroomQueryValue != FilterAnyLabels.BELIEBIG
			? enforceArray(
				enforceArray(
					Object.values(NumberOfRooms).find(
						(room) => room.value === bedroomQueryValue
					)?.label
				).pop()
			)
			: enforceArray(FilterAnyLabels.BELIEBIG)
	);
	useEffect(() => {
		if (bedroomSelectedItems[0] === FilterAnyLabels.BELIEBIG) {
			const query = router.query;
			delete query[Filter.BedroomsTotal.queryKey];
			replaceRouterQueryParamsShallow(router, query);
		}
	}, [bedroomSelectedItems]);

	const propertyTypeQueryValue = enforceArray(
		router.query[PropertyTypeQueryKey]
	) ?? [FilterAnyLabels.BELIEBIG];
	const propertyTypeQueryLabels = VermietungCategories.PropertyType.children
		.filter((child) => {
			const values = child.values;
			if (values && values.every((v) => propertyTypeQueryValue.includes(v)))
				return child;
		})
		.map((vermietungFilter) => vermietungFilter.label);

	const [propertyTypeSelectedItems, setPropertyTypeSelectedItems] = useState<
		string[]
	>(
		propertyTypeQueryLabels.length > 0
			? propertyTypeQueryLabels
			: [FilterAnyLabels.BELIEBIG]
	);

	const ausstattungQueryLabels = VermietungCategories.Ausstatung.children
		.filter((child) => {
			if (router.query[child.queryKey]) return child;
		})
		.map((child) => child.label);
	const [ausstattungSelectedItems, setAusstattungSelectedItems] = useState<
		string[]
	>(
		enforceArray(ausstattungQueryLabels).length > 0
			? enforceArray(ausstattungQueryLabels)
			: [FilterAnyLabels.BELIEBIG]
	);

	function handleSelectedStates(
		item: string | number,
		checked: boolean,
		selectedItems: string[]
	) {
		let newSelectedItems = selectedItems;
		const stringifiedItem = item.toString();
		if (checked && !newSelectedItems.includes(stringifiedItem)) {
			newSelectedItems.push(stringifiedItem);
			newSelectedItems = newSelectedItems.filter(
				(i) => i !== FilterAnyLabels.BELIEBIG
			);
			newSelectedItems = newSelectedItems.filter(
				(i) => i !== FilterAnyLabels.BELIEBIG
			);
		}
		if (!checked && newSelectedItems.includes(stringifiedItem)) {
			newSelectedItems = newSelectedItems.filter((i) => i !== stringifiedItem);
		}
		if (newSelectedItems.length === 0 || item === FilterAnyLabels.BELIEBIG) {
			newSelectedItems = [FilterAnyLabels.BELIEBIG];
		}
		if (newSelectedItems.length === 0 || item === FilterAnyLabels.BELIEBIG) {
			newSelectedItems = [FilterAnyLabels.BELIEBIG];
		}
		return newSelectedItems;
	}

	function handleReset() {
		replaceRouterQueryParamsShallow(router);
		setBedroomSelectedItems([FilterAnyLabels.BELIEBIG]);
		setPropertyTypeSelectedItems([FilterAnyLabels.BELIEBIG]);
		setAusstattungSelectedItems([FilterAnyLabels.BELIEBIG]);
	}

	return (
		<MobileFilterMenu
			items={{
				bedrooms: {
					selected: bedroomSelectedItems,
					label: t(Filter.BedroomsTotal.label),
					menu: (
						<Checklist
							mobileVersion
							items={
								SchlafzimmerItems(router).items?.map((i) => {
									return {
										id: i,
										primaryLabel: i,
										checked: bedroomSelectedItems.includes(i) ? true : false
									};
								}) ?? []
							}
							onChange={(item, checked) => {
								setBedroomSelectedItems(
									handleSelectedStates(item, checked, [])
								);
								handleDropdownSelect(
									SchlafzimmerItems(router).title,
									enforceArray({name: item}),
									router,
									t
								);
							}}
						/>
					)
				},
				propertyType: {
					selected: propertyTypeSelectedItems,
					label: t(VermietungCategories.PropertyType.label),
					menu: (
						<Checklist
							mobileVersion
							items={ArtDerUnterkunftItems(router).items}
							onChange={(item, checked) => {
								handleChecklistFilterChange(item, checked, router);
								setPropertyTypeSelectedItems(
									handleSelectedStates(item, checked, propertyTypeSelectedItems)
								);
							}}
						/>
					)
				},
				ausstattung: {
					selected: ausstattungSelectedItems,
					label: t(VermietungCategories.Ausstatung.label),
					menu: (
						<Checklist
							mobileVersion
							items={AusstattungItems(router).items}
							onChange={(item, checked) => {
								handleChecklistFilterChange(item, checked, router);
								setAusstattungSelectedItems(
									handleSelectedStates(item, checked, ausstattungSelectedItems)
								);
							}}
						/>
					)
				}
			}}
			open={props.open}
			onClose={props.onClose}
			onSearchChange={(v) => handleSearchChange(v, router)}
			onResetFilter={handleReset}
		/>
	);
}
